import { useEffect, useState } from "react";

const NiceJobWidget = () => {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    let loaded = false;
    const trigger = () => {
      if (loaded) return;
      loaded = true;
      setShouldLoad(true);
      cleanup();
    };

    const cleanup = () => {
      window.removeEventListener("scroll", trigger);
      window.removeEventListener("pointerdown", trigger);
      window.removeEventListener("keydown", trigger);
      window.removeEventListener("touchstart", trigger);
    };

    // Defer until first user interaction so the third-party widget never hurts initial load.
    window.addEventListener("scroll", trigger, { passive: true, once: true });
    window.addEventListener("pointerdown", trigger, { once: true });
    window.addEventListener("keydown", trigger, { once: true });
    window.addEventListener("touchstart", trigger, { passive: true, once: true });
    return () => {
      cleanup();
    };
  }, []);

  useEffect(() => {
    if (!shouldLoad) return;
    if (document.getElementById("nicejob-sdk")) return;
    const script = document.createElement("script");
    script.id = "nicejob-sdk";
    script.src =
      "https://cdn.nicejob.co/js/sdk.min.js?id=a1f33915-8794-47d9-a338-0b1de46d36d9";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, [shouldLoad]);

  return <div className="nj-engage" data-position="left" />;
};

export default NiceJobWidget;
